import { render, staticRenderFns } from "./TripTable.vue?vue&type=template&id=15bf47c0&scoped=true&"
import script from "./TripTable.vue?vue&type=script&lang=js&"
export * from "./TripTable.vue?vue&type=script&lang=js&"
import style0 from "./TripTable.vue?vue&type=style&index=0&id=15bf47c0&scoped=true&lang=css&"
import style1 from "./TripTable.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bf47c0",
  null
  
)

export default component.exports